<div class="screen screen--split">

  <app-theme-header></app-theme-header>

  <h1 class="screen__title">Please Proceed<br />The Payment</h1>

  <div class="screen__stage">

    <div class="panel qr-panel">

      <div class="qr-plate" *ngIf="host.OmiseLinkUrl && !host.isQrError">
        <qrcode [qrdata]="host.OmiseLinkUrl" [width]="256" [errorCorrectionLevel]="'M'" [margin]="0"></qrcode>
      </div>

      <div class="qr-plate qr-plate--error" *ngIf="host.isQrError">
        <img class="qr-plate__code" src="assets/img/maintenance.png" alt="" />
      </div>

      <img class="qr-panel__brand" src="assets/img/LINK.png" alt="LINK" *ngIf="!host.isQrError" />

      <ng-container *ngIf="!host.isQrError && !host.commonService.isLoading">
        <hr class="hairline" />
        <div class="qr-panel__total">
          <span class="qr-panel__total-label">TOTAL</span>
          <span class="amount-box">{{ host.amountSum | number: ".2" }} {{ host.TXT_PAYMENT_SCAN_CURRENCY }}</span>
        </div>
      </ng-container>

      <div class="screen__notice" *ngIf="host.isQrError">
        {{ host.TXT_PAYMENT_SCAN_QR_ERROR_TITLE }}<br />{{ host.TXT_PAYMENT_SCAN_QR_ERROR_SUBTITLE }}
      </div>

    </div>

    <button type="button" class="outline-button outline-button--primary" (click)="host.onCheck()"
      *ngIf="host.OmiseLinkUrl" [disabled]="host.commonService.isLoading">
      {{ host.checkLabel }}
    </button>

  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.onBack()">BACK</button>
  </div>

</div>
